import styled from "styled-components"

import Button from "../../Button"

interface RadioFilterProps {
  overflow?: boolean
}

export const StyledButton = styled(Button)`
  font-size: 8px;
  padding: 8px;
`
export const Wrapper = styled.div<RadioFilterProps>`
  max-height: 350px;
  overflow-y: ${({overflow}) => (overflow ? "visible" : "auto")};
`
